import jQuery from 'jquery';

// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function noop() {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

// ----------------
// Helper Functions
// ----------------
(function(w){
	// All helper functions attached to _ad object to avoid polluting the global namespace
	var _ad = w._ad || {};

	_ad.window = w;

	// For Each
	_ad.forEach = function(itemInArray, doThis){
		for(var i = 0; i < itemInArray.length; i++)
		{
			doThis(itemInArray[i]);
		}
	};

	// Query String
	_ad.qString = function(url){
		// For current url use: window.location.search
		// Object for holding query variables
		var query = {};

		if (url.indexOf('?') < 0)
			return false;

		// Split the url to get the basic query string
		var queries = url.substr(url.indexOf('?') + 1).split('&');
		_ad.forEach(queries, function(item){
			var key = item.substr(0, item.indexOf('='))
			// var val = item.substr(item.indexOf('=') + 1);
			var val = decodeURIComponent(item.substr(item.indexOf('=') + 1).replace(/\+/g, ' '));
			query[key] = val;
		});

		return query;
	};

	_ad.qStringObj = function(){
		this.query = {};

		if (arguments[0] !== undefined) {
			this.query = _ad.qString(arguments[0]) || {};
		}

		this.add = function(key, value) {
			if (key === undefined || value === undefined) {
				try {
					console.error('Please enter both a key and a value.');
				}
				catch(err) {
					alert('Please enter both a key and a value.');
				};
				return false;
			}

			this.query[key] = value;
			return value;
		};

		this.remove = function(key) {
			if (key === undefined) {
				try {
					console.error('Please enter a key to remove.')
				}
				catch (err) {
					alert('Please enter a key to remove.')
				};
			}

			if (key in this.query) {
				delete this.query[key];
			} else {
				try {
					console.error('The key "'+key+'" does not exist');
				}
				catch (err) {
					alert('The key "'+key+'" does not exist')
				};
				return false;
			}
			return true;
		};

		this.qString = function() {
			var str = '',
				term = '?';


			for (key in this.query) {
				str = str + term + key + '=' +this.query[key];
				term = '&';
			}
			return str;
		};
	};

	// Transition End
	_ad.bindTransitionEnd = function(toElement, withFunction){
		toElement.addEventListener('transitionend', withFunction, false);
	    toElement.addEventListener('webkitTransitionEnd', withFunction, false);
	    toElement.addEventListener('oTransitionEnd', withFunction, false);
	    toElement.addEventListener('otransitionend', withFunction, false);
	};

	// nthIndexOf
	_ad.nthIndexOf = function(src, target){
		var nth = arguments[2] ? arguments[2] : 1;
		var index = -1;

		for (var i = 0; i < nth; i++)
		{
			index = src.indexOf(target, index + 1);
		}
		return index;
	};

	// Check Height
	_ad.getTallest = function(_el) {
		var height = 0;
		_el.each(function(index, el){
			el.style.height = 'auto';
			var elHeight = parseInt(el.offsetHeight);
			if (elHeight > height) {
				height = elHeight;
			}
		});
		return height;
	}
	_ad.checkHeight = function(_el){
		var height = 0;
		var min = parseInt(_el.css('min-height')) || 0;
		var lineHeight = arguments[1] ? arguments[1] : false // If second parameter is true also set the line-height of the elements //
		height = min;
		_el.css({ height: 'auto' }).each(function(index, element){
			var thisHeight = $(this).outerHeight();
			thisHeight = this.offsetHeight;
			if (thisHeight > height)
				height = thisHeight;
		});

		if (arguments[3] ? arguments[3] : false) {
			_el.css({ minHeight: height });
		} else {
			_el.css({ height: height });
		}

		if (lineHeight)
			_el.css({ lineHeight: height+'px' });

		if (arguments[2] ? arguments[2] : false) { // If third parameter is true then poll for changes //
			setInterval(function(){
				_el.css({ height: _ad.getTallest(_el) });
			}, 500);
		}
		return height;
	};

	// Window Dimensions
	_ad.windowWidth = function() {
		var w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0],
		x = w.innerWidth || e.clientWidth || g.clientWidth;
		return x;
	}
	_ad.windowHeight = function() {
		var w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0],
		y = w.innerHeight|| e.clientHeight|| g.clientHeight;
		return y;
	}
	w._ad = _ad;
})(window);


// Transition end event helper
var transEndEventNames = {
		'WebkitTransition': 'webkitTransitionEnd',
		'MozTransition': 'transitionend',
		'OTransition': 'oTransitionEnd',
		'msTransition': 'MSTransitionEnd',
		'transition': 'transitionend'
	},
	transEndEventName = transEndEventNames[Modernizr.prefixed('transition')],
	transEndEventNameConcat = 'webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd';


// Cookies
function createCookie(name,value,days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}
	else expires = "";
	document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}


// (function(){})(window);

// Non-jQuery class manipulation //
function addClass(el, className) {
	if (!el) return false;
	if (el.classList)
		el.classList.add(className);
	else
		el.className += ' ' + className;
}

function removeClass(el, className) {
	if (!el) return false;
	if (el.classList)
		el.classList.remove(className);
	else
		el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}

function toggleClass(el, className) {
	if (!el) return false;
	if (el.classList) {
		el.classList.toggle(className);
	} else {
		var classes = el.className.split(' ');
		var existingIndex = -1;
		for (var i = classes.length; i--;) {
			if (classes[i] === className)
				existingIndex = i;
		}

		if (existingIndex >= 0)
			classes.splice(existingIndex, 1);
		else
			classes.push(className);

		el.className = classes.join(' ');
	}
}

function hasClass(el, className) {
	if (!el) return false;
	if (el.classList)
		return el.classList.contains(className);
	else
		return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
}

function children(el) {
	var children = [];
	for (var i=el.children.length; i--;){
		// Skip comment nodes on IE8
		if (el.children[i].nodeType != 8)
			children.unshift(el.children[i]);
	}
	return children;
};

function siblings(el) {
	// var siblings = Array.prototype.slice.call(el.parentNode.children);
	var siblings = Array.prototype.slice.call(children(el.parentNode));

	for (var i = siblings.length; i--;) {
		if (siblings[i] === el) {
			siblings.splice(i, 1);
			break;
		}
	}

	return siblings;
}

function nextSibling(el) {
	// nextSibling can include text nodes
	function nextElementSibling(el) {
		do { el = el.nextSibling; } while ( el && el.nodeType !== 1 );
		return el;
	}

	return el.nextElementSibling || nextElementSibling(el);
}


function scrollTop() {
	return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
}

function scrollLeft() {
	return (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
}

function setText(el, text) {
	if (el.textContent !== undefined)
		el.textContent = text;
	else
		el.innerText = text;
}

function arrValueIn(arr, val) {
	var ret = false;
	_ad.forEach(arr, function(item){
		if (item === val) ret = true;
	});
	return ret;
}

function pad(num, size) {
    var s = "0" + num;
    return s.substr(s.length-size);
}

// Popups
(function($){
	var popupCurr = null,
		_elOverlay = document.querySelector('.overlay'),
		lastFocus;

	function setCssTop(el){
		var top = 0;

		top = (_ad.windowHeight() / 2) - (el.offsetHeight / 2) + scrollTop();

		top = top > 0 ? top : 0;

		return top + 'px';
	};

	$('.js-popup')
		.each(function(index, el){
			var _popup = $(el);

			_popup
				.on('open.popup', function(){
					if (popupCurr !== null) {
						$(popupCurr).trigger('close.popup', true);
					} else {
						lastFocus = document.activeElement;
						removeClass(_elOverlay, 'hide');
						setTimeout(function(){
							addClass(_elOverlay, 'show');
						},0);
					}

					// console.log('Open: ',popupCurr);

					removeClass(el, 'hide');
					setTimeout(function(){
						el.style.top = setCssTop(el);
						addClass(el, 'show');
					},0);

					popupCurr = this;
				})
				.on('close.popup', function(event){
					popupCurr = null;

					var switchPopup = arguments[1] || false;

					if (!switchPopup) {
						removeClass(_elOverlay, 'show');
						lastFocus.focus();

						if (!Modernizr.csstransitions) {
							addClass(_elOverlay, 'hide');
						}
					}

					removeClass(this, 'show');

					if (!Modernizr.csstransitions) {
						addClass(this, 'hide');
					}

					// console.log('Close: ',popupCurr);
				})
				.on(transEndEventNameConcat, function(){
					if (!hasClass(this, 'show')) {
						addClass(this, 'hide');
					}
				});
		});

	$('.js-popup-open')
		.on('click', function(event){
			event.preventDefault();
			var target = this.getAttribute('data-popup'),
				_elPopup = document.getElementById(target);

			$(_elPopup).trigger('open.popup');
		});

	$('.js-popup-close')
		.on('click', function(event){
			event.preventDefault();
			if (popupCurr !== null) {
				$(popupCurr).trigger('close.popup');
			}
		});

	$(_elOverlay)
		.on('click', function(event){
			event.preventDefault();
			if (popupCurr !== null) {
				$(popupCurr).trigger('close.popup');
			}
		})
		.on(transEndEventNameConcat, function(){
			if (!hasClass(this, 'show')) {
				addClass(this, 'hide');
			}
		});
})(jQuery);

export { transEndEventName, scrollTop, addClass, removeClass, hasClass, toggleClass, nextSibling };